<div class="loading-screen">
  <div class="loading-content">
    <div class="logo-container">
      <div class="logo-3d">
        <span class="logo">
          <img src="assets/Hnet-Finalsvg-01-01.svg" alt="HorizonNet Logo">
        </span>
      </div>
    </div>
    <div class="loading-bar">
      <div class="loading-progress"></div>
    </div>
  </div>
</div> 